(function () {
  'use strict';

  var runTimer = null;
  var isRunning = false;

  function normalize(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getOptionIndex(input) {
    var match = String(
      input.getAttribute('data-index') || ''
    ).match(/option(\d+)/i);

    if (!match) {
      return -1;
    }

    return parseInt(match[1], 10) - 1;
  }

  function parseVariantOption(option) {
    var originalText = String(option.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();

    var variantText = originalText;

    /*
     * Example:
     *
     * Military Olive / 4.5 M / Standard - PKR 9,000
     * Military Olive / 4.5 M / Signature Box - Sold Out
     */

    var separator = variantText.lastIndexOf(' - ');

    if (separator !== -1) {
      variantText = variantText.substring(0, separator);
    }

    var values = variantText
      .split(/\s*\/\s*/)
      .map(function (value) {
        return value.trim();
      });

    return {
      values: values,

      /*
       * Your Shopify HTML disables the sold-out <option>.
       * We also check the text as a fallback.
       */
      available:
        !option.disabled &&
        !/\bsold\s*out\b/i.test(originalText)
    };
  }

  function getInputsForForm(form) {
    return Array.prototype.slice
      .call(
        document.querySelectorAll(
          '[data-variant-input]'
        )
      )
      .filter(function (input) {
        /*
         * Using input.form is much safer than matching the
         * "form" attribute as a CSS selector.
         */
        return input.form === form;
      });
  }

  function getGroups(inputs) {
    var groups = {};

    inputs.forEach(function (input) {
      var index = getOptionIndex(input);

      if (index < 0) {
        return;
      }

      if (!groups[index]) {
        var fieldset =
          input.closest('.variant-input-wrap');

        groups[index] = {
          index: index,
          name: input.getAttribute('name') || '',
          handle: fieldset
            ? fieldset.getAttribute('data-handle') || ''
            : '',
          inputs: []
        };
      }

      groups[index].inputs.push(input);
    });

    return Object.keys(groups)
      .map(function (key) {
        return groups[key];
      })
      .sort(function (a, b) {
        return a.index - b.index;
      });
  }

  function getSelectedValues(groups) {
    var selected = {};

    groups.forEach(function (group) {
      var checked = group.inputs.find(function (input) {
        return input.checked;
      });

      if (checked) {
        selected[group.index] = checked.value;
      }
    });

    return selected;
  }

  function findPackagingGroup(groups) {
    return groups.find(function (group) {
      /*
       * Detect Packaging normally.
       */
      if (
        normalize(group.name) === 'packaging' ||
        normalize(group.handle) === 'packaging'
      ) {
        return true;
      }

      /*
       * Fallback:
       * any option group containing Signature Box.
       */
      return group.inputs.some(function (input) {
        return normalize(input.value) ===
          'signature box';
      });
    });
  }

  function variantMatchesRequiredValues(
    variant,
    requiredValues
  ) {
    return Object.keys(requiredValues).every(
      function (key) {
        var index = parseInt(key, 10);

        return (
          normalize(variant.values[index]) ===
          normalize(requiredValues[index])
        );
      }
    );
  }

  /*
   * CRITICAL LOGIC
   *
   * When calculating Color / Length availability:
   * IGNORE Packaging.
   *
   * When calculating Packaging availability:
   * use selected Color + Length.
   *
   * Therefore:
   *
   * Military Olive / Standard = in stock
   * Military Olive / Signature Box = sold out
   *
   * RESULT:
   *
   * Military Olive = available
   * Signature Box = sold out
   */
  function optionIsAvailable(
    input,
    group,
    groups,
    packagingIndex,
    selected,
    variants
  ) {
    var required = {};

    required[group.index] = input.value;

    groups.forEach(function (otherGroup) {
      if (otherGroup.index === group.index) {
        return;
      }

      /*
       * Packaging must NOT poison the Color/Length
       * availability calculation.
       */
      if (otherGroup.index === packagingIndex) {
        return;
      }

      var selectedValue =
        selected[otherGroup.index];

      if (selectedValue) {
        required[otherGroup.index] =
          selectedValue;
      }
    });

    return variants.some(function (variant) {
      return (
        variant.available &&
        variantMatchesRequiredValues(
          variant,
          required
        )
      );
    });
  }

  function toggleClass(element, className, enabled) {
    if (!element) {
      return;
    }

    if (
      enabled &&
      !element.classList.contains(className)
    ) {
      element.classList.add(className);
    }

    if (
      !enabled &&
      element.classList.contains(className)
    ) {
      element.classList.remove(className);
    }
  }

  function ensureSignatureSoldOutStyles() {
    if (
      document.getElementById(
        'afi-signature-soldout-styles'
      )
    ) {
      return;
    }

    var style = document.createElement('style');

    style.id = 'afi-signature-soldout-styles';

    style.textContent = [
      '.variant-input-wrap[data-afi-packaging-group="true"] {',
      '  align-items: flex-start !important;',
      '}',
      '.variant-input[data-afi-packaging="true"] {',
      '  vertical-align: top !important;',
      '}',
      '.variant-input.afi-signature-clickable-soldout {',
      '  vertical-align: top !important;',
      '  pointer-events: auto !important;',
      '}',
      '.variant-input.afi-signature-clickable-soldout .variant__button-label {',
      '  position: relative !important;',
      '  overflow: hidden;',
      '  pointer-events: auto !important;',
      '  cursor: pointer !important;',
      '}',
      '.afi-signature-cross {',
      '  display: none;',
      '  position: absolute;',
      '  inset: 0;',
      '  z-index: 3;',
      '  pointer-events: none;',
      '}',
      '.afi-signature-clickable-soldout .afi-signature-cross {',
      '  display: block;',
      '}',
      '.afi-signature-cross::before,',
      '.afi-signature-cross::after {',
      '  content: "";',
      '  position: absolute;',
      '  left: -4%;',
      '  top: 50%;',
      '  width: 108%;',
      '  height: 2px;',
      '  background: #ef2b2d;',
      '  transform-origin: center;',
      '}',
      '.afi-signature-cross::before {',
      '  transform: translateY(-50%) rotate(11deg);',
      '}',
      '.afi-signature-cross::after {',
      '  transform: translateY(-50%) rotate(-11deg);',
      '}',
      '.afi-signature-soldout-note[hidden] {',
      '  display: none !important;',
      '}',
      '.afi-signature-soldout-note {',
      '  display: flex;',
      '  align-items: center;',
      '  gap: 6px;',
      '  margin-top: 7px;',
      '  font-size: 12px;',
      '  line-height: 1.2;',
      '  white-space: nowrap;',
      '  color: inherit;',
      '}',
      '.afi-signature-soldout-dot {',
      '  display: inline-block;',
      '  width: 7px;',
      '  height: 7px;',
      '  flex: 0 0 7px;',
      '  border-radius: 50%;',
      '  background: #d32f2f;',
      '}'
    ].join('\n');

    (document.head || document.documentElement)
      .appendChild(style);
  }

  function setSignatureSoldOutNote(
    input,
    visible
  ) {
    var container =
      input.closest('.variant-input');

    if (!container) {
      return;
    }

    var note =
      container.querySelector(
        '.afi-signature-soldout-note'
      );

    toggleClass(
      container,
      'afi-signature-clickable-soldout',
      visible
    );

    if (!visible) {
      if (note) {
        note.hidden = true;
      }

      return;
    }

    ensureSignatureSoldOutStyles();

    var label =
      container.querySelector(
        '.variant__button-label'
      );

    if (
      label &&
      !label.querySelector('.afi-signature-cross')
    ) {
      var cross = document.createElement('span');
      cross.className = 'afi-signature-cross';
      cross.setAttribute('aria-hidden', 'true');
      label.appendChild(cross);
    }

    if (!note) {
      note = document.createElement('div');
      note.className =
        'afi-signature-soldout-note';
      note.setAttribute('role', 'status');

      var dot = document.createElement('span');
      dot.className =
        'afi-signature-soldout-dot';
      dot.setAttribute('aria-hidden', 'true');

      var text = document.createElement('span');
      text.textContent = 'Sold Out';

      note.appendChild(dot);
      note.appendChild(text);
      container.appendChild(note);
    }

    note.hidden = false;
  }

  function setAvailabilityState(
    input,
    available,
    isPackaging
  ) {
    var container =
      input.closest('.variant-input');

    if (!container) {
      return;
    }

    var label =
      container.querySelector(
        '.variant__button-label'
      );

    var isSignatureBox =
      isPackaging &&
      normalize(input.value) ===
        'signature box';

    /*
     * These classes are OUR source of truth.
     */
    toggleClass(
      container,
      'afi-option-available',
      available
    );

    toggleClass(
      container,
      'afi-option-soldout',
      !available
    );

    if (isPackaging) {
      container.setAttribute(
        'data-afi-packaging',
        'true'
      );

      var packagingWrapper =
        container.closest('.variant-input-wrap');

      if (packagingWrapper) {
        packagingWrapper.setAttribute(
          'data-afi-packaging-group',
          'true'
        );
      }
    }

    if (isSignatureBox) {
      setSignatureSoldOutNote(
        input,
        !available
      );
    }

    /*
     * The theme currently applies this incorrectly
     * to your Colors.
     *
     * Explicitly remove it whenever our correct
     * calculation says the option is available.
     */
    if (available) {
      container.classList.remove(
        'is-sold-out-swatch'
      );

      input.disabled = false;

      input.setAttribute(
        'aria-disabled',
        'false'
      );

      if (label) {
        label.setAttribute(
          'aria-disabled',
          'false'
        );
      }
    } else {
      /*
       * Do not leave the theme's own sold-out class on
       * Signature Box. Some themes use that class to
       * cancel/rerender clicks, which causes the visible
       * flicker. Our custom class keeps the red cross and
       * Sold Out note stable instead.
       */
      if (isSignatureBox) {
        container.classList.remove(
          'is-sold-out-swatch'
        );
      } else {
        container.classList.add(
          'is-sold-out-swatch'
        );
      }

      /*
       * Signature Box stays enabled so it can be selected
       * for price viewing. Other sold-out options remain
       * disabled exactly as before.
       */
      input.disabled = !isSignatureBox;

      input.setAttribute(
        'aria-disabled',
        isSignatureBox ? 'false' : 'true'
      );

      if (label) {
        label.setAttribute(
          'aria-disabled',
          isSignatureBox ? 'false' : 'true'
        );
      }
    }
  }

  function findAvailablePackagingFallback(
    packagingGroup,
    groups,
    packagingIndex,
    selected,
    variants
  ) {
    /*
     * Prefer Standard.
     */
    var standard =
      packagingGroup.inputs.find(
        function (input) {
          return (
            normalize(input.value) ===
            'standard'
          );
        }
      );

    if (
      standard &&
      optionIsAvailable(
        standard,
        packagingGroup,
        groups,
        packagingIndex,
        selected,
        variants
      )
    ) {
      return standard;
    }

    /*
     * Otherwise use the first available Packaging
     * option.
     */
    return packagingGroup.inputs.find(
      function (input) {
        return optionIsAvailable(
          input,
          packagingGroup,
          groups,
          packagingIndex,
          selected,
          variants
        );
      }
    );
  }

  function fixProduct(select) {
    var form =
      select.form ||
      select.closest('form');

    if (!form) {
      return;
    }

    var inputs =
      getInputsForForm(form);

    if (!inputs.length) {
      return;
    }

    var groups =
      getGroups(inputs);

    if (!groups.length) {
      return;
    }

    var packagingGroup =
      findPackagingGroup(groups);

    /*
     * Product doesn't use our Signature Box system.
     * Leave it completely alone.
     */
    if (!packagingGroup) {
      return;
    }

    var signatureInput =
      packagingGroup.inputs.find(
        function (input) {
          return (
            normalize(input.value) ===
            'signature box'
          );
        }
      );

    if (!signatureInput) {
      return;
    }

    var packagingIndex =
      packagingGroup.index;

    var variants =
      Array.prototype.slice
        .call(select.options)
        .map(parseVariantOption);

    if (!variants.length) {
      return;
    }

    var selected =
      getSelectedValues(groups);

    /*
     * --------------------------------------------------
     * STEP 1
     * --------------------------------------------------
     *
     * Do NOT force a sold-out Signature Box back to
     * Standard. Customers are allowed to select it so
     * the theme can show the Signature Box price.
     * setAvailabilityState() keeps it non-purchasable
     * but clickable.
     */

    /*
     * --------------------------------------------------
     * STEP 2
     * --------------------------------------------------
     *
     * Correct every option.
     */
    groups.forEach(function (group) {
      group.inputs.forEach(function (input) {
        var available =
          optionIsAvailable(
            input,
            group,
            groups,
            packagingIndex,
            selected,
            variants
          );

        setAvailabilityState(
          input,
          available,
          group.index === packagingIndex
        );
      });
    });

    /*
     * --------------------------------------------------
     * STEP 3
     * --------------------------------------------------
     *
     * Fix the large "Out of stock" message.
     *
     * Packaging is intentionally ignored here.
     * If the selected Color + Length has ANY purchasable
     * packaging combination (normally Standard), the
     * product is NOT generally out of stock.
     */
    var nonPackagingRequired = {};

    groups.forEach(function (group) {
      if (group.index === packagingIndex) {
        return;
      }

      var selectedValue =
        selected[group.index];

      if (selectedValue) {
        nonPackagingRequired[group.index] =
          selectedValue;
      }
    });

    var baseProductAvailable =
      variants.some(function (variant) {
        return (
          variant.available &&
          variantMatchesRequiredValues(
            variant,
            nonPackagingRequired
          )
        );
      });

    /*
     * Find the product block containing the variant
     * selectors.
     */
    var firstWrapper =
      inputs[0].closest('.product-block');

    var inventoryMessage =
      firstWrapper
        ? firstWrapper.querySelector(
            '.custom-oos-inventory'
          )
        : null;

    if (inventoryMessage) {
      toggleClass(
        inventoryMessage,
        'is-visible',
        !baseProductAvailable
      );
    }
  }

  function runFix() {
    if (isRunning) {
      return;
    }

    isRunning = true;

    try {
      document
        .querySelectorAll(
          '[data-product-select]'
        )
        .forEach(function (select) {
          fixProduct(select);
        });

      /*
       * Diagnostic marker.
       *
       * If this appears on <html>, you KNOW this
       * JavaScript asset loaded successfully.
       */
      document.documentElement.setAttribute(
        'data-afi-signature-fix',
        'active'
      );
    } finally {
      isRunning = false;
    }
  }

  function scheduleFix(delay) {
    window.setTimeout(
      runFix,
      typeof delay === 'number'
        ? delay
        : 0
    );
  }

  /*
   * --------------------------------------------------
   * INITIAL LOAD
   * --------------------------------------------------
   */

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        scheduleFix(0);
        scheduleFix(100);
        scheduleFix(300);
        scheduleFix(700);
      }
    );
  } else {
    scheduleFix(0);
    scheduleFix(100);
    scheduleFix(300);
    scheduleFix(700);
  }

  /*
   * --------------------------------------------------
   * VARIANT CHANGES
   * --------------------------------------------------
   */

  document.addEventListener(
    'change',
    function (event) {
      if (
        !event.target.matches(
          '[data-variant-input]'
        )
      ) {
        return;
      }

      /*
       * Run AFTER the theme's normal variant code.
       */
      scheduleFix(0);
      scheduleFix(50);
      scheduleFix(150);
      scheduleFix(350);
    }
  );

  document.addEventListener(
    'click',
    function (event) {
      var soldOutPackaging =
        event.target.closest(
          '.variant-input' +
          '[data-afi-packaging="true"]' +
          '.afi-option-soldout'
        );

      if (!soldOutPackaging) {
        return;
      }

      var soldOutInput =
        soldOutPackaging.querySelector(
          '[data-variant-input]'
        );

      /*
       * Signature Box is the one exception. Handle the
       * selection ourselves instead of letting the
       * theme's sold-out click logic fight the browser.
       * This removes the click/selection flicker while
       * still firing the normal variant change event so
       * the Signature Box price can be displayed.
       */
      if (
        soldOutInput &&
        normalize(soldOutInput.value) ===
          'signature box'
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();

        soldOutInput.disabled = false;
        soldOutInput.setAttribute(
          'aria-disabled',
          'false'
        );

        if (!soldOutInput.checked) {
          soldOutInput.checked = true;

          soldOutInput.dispatchEvent(
            new Event('input', {
              bubbles: true
            })
          );

          soldOutInput.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );
        }

        scheduleFix(0);
        scheduleFix(80);

        return;
      }

      /*
       * Other sold-out Packaging options remain blocked.
       */
      event.preventDefault();
      event.stopImmediatePropagation();

      scheduleFix(0);
    },
    true
  );

  /*
   * Common Shopify/theme variant events.
   */
  [
    'variant:change',
    'variantChange',
    'product:variant-change'
  ].forEach(function (eventName) {
    document.addEventListener(
      eventName,
      function () {
        scheduleFix(0);
        scheduleFix(80);
        scheduleFix(250);
      }
    );
  });

  /*
   * --------------------------------------------------
   * THEME EDITOR / QUICK VIEW / AJAX
   * --------------------------------------------------
   */

  document.addEventListener(
    'shopify:section:load',
    function () {
      scheduleFix(0);
      scheduleFix(100);
      scheduleFix(300);
    }
  );

  /*
   * Your theme appears to modify sold-out classes
   * dynamically.
   *
   * Watch only variant areas instead of watching every
   * class change across the whole website.
   */
  var observedElements = [];

  var attributeObserver =
    new MutationObserver(function () {
      if (isRunning) {
        return;
      }

      scheduleFix(20);
    });

  function observeVariantAreas() {
    document
      .querySelectorAll(
        '.variant-wrapper'
      )
      .forEach(function (wrapper) {
        if (
          observedElements.indexOf(wrapper) !== -1
        ) {
          return;
        }

        observedElements.push(wrapper);

        attributeObserver.observe(
          wrapper,
          {
            subtree: true,
            attributes: true,
            attributeFilter: [
              'class',
              'disabled',
              'aria-disabled'
            ]
          }
        );
      });
  }

  var childObserver =
    new MutationObserver(function () {
      observeVariantAreas();

      scheduleFix(30);
    });

  function startObservers() {
    observeVariantAreas();

    if (document.body) {
      childObserver.observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );
    }
  }

  if (document.body) {
    startObservers();
  } else {
    document.addEventListener(
      'DOMContentLoaded',
      startObservers
    );
  }

  console.info(
    '[AFI] Signature Box availability fix loaded.'
  );
})();